// src/pages/reports/SalesReportPage.jsx
import React from 'react';
import { Box, Heading, HStack, Button, Text } from '@chakra-ui/react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ReportEditor from '../ReportEditor';

export default function SalesReportPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const leadId = params.get('leadId') || '';
  const backParam = params.get('back') || '/reports/sales';
  const back = typeof backParam === 'string' && backParam.startsWith('/') ? backParam : '/reports/sales';

  return (
    <Box>
      <HStack justify="space-between" mb={3}>
        <Heading size="lg" color="blue.600">Sales Report</Heading>
        <Button variant="outline" onClick={() => navigate(back)}>Back</Button>
      </HStack>

      {leadId ? (
        <ReportEditor leadId={leadId} onClose={() => navigate(back)} />
      ) : (
        <Text color="gray.600">No lead selected. Provide a lead via <code>?leadId=</code>.</Text>
      )}
    </Box>
  );
}
